import { LazyModule, createLazyComponent, LazyImport } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "AccountsFeedback"*/ './lazyIndex')
);

export const TrueTimeDisabledFeedbackRibbon = createLazyComponent(
    lazyModule,
    m => m.TrueTimeDisabledFeedbackRibbon
);

export const lazyGetHasShownAddAccountFailureFeedbackDialog = new LazyImport(
    lazyModule,
    m => m.getHasShownAddAccountFailureFeedbackDialog
);
export const lazyGetHasShownDisconnectFeedbackDialog = new LazyImport(
    lazyModule,
    m => m.getHasShownDisconnectFeedbackDialog
);

export { showAddAccountFailureFeedbackDialog } from './actions';
export { showDisconnectFeedbackDialog } from './actions';

// exporting this action directly so consumers can listen
export { default as AccountsFeedbackInitSource } from './store/schema/AccountsFeedbackInitSource';
